export default function ChevronUpIcon() {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.29259 12.707C5.48012 12.8944 5.73443 12.9998 5.99959 12.9998C6.26476 12.9998 6.51906 12.8944 6.70659 12.707L9.99959 9.41397L13.2926 12.707C13.4812 12.8891 13.7338 12.9899 13.996 12.9876C14.2582 12.9854 14.509 12.8802 14.6944 12.6948C14.8798 12.5094 14.985 12.2586 14.9873 11.9964C14.9895 11.7342 14.8888 11.4816 14.7066 11.293L10.7066 7.29297C10.5191 7.1055 10.2648 7.00018 9.99959 7.00018C9.73443 7.00018 9.48012 7.1055 9.29259 7.29297L5.29259 11.293C5.10512 11.4805 4.99981 11.7348 4.99981 12C4.99981 12.2651 5.10512 12.5194 5.29259 12.707Z'
        fill='currentColor'
        fillOpacity='0.5'
      />
    </svg>
  )
}
